import { constants, utils } from '@adc/ui-core'
import * as graph from '@adc/sdk'

export const globalPhysicalStructures =
  constants.optionLists.globalPhysicalStructures

export const daysOfWeek = [
  { value: '1', text: 'Monday' },
  { value: '2', text: 'Tuesday' },
  { value: '3', text: 'Wednesday' },
  { value: '4', text: 'Thursday' },
  { value: '5', text: 'Friday' },
  { value: '6', text: 'Saturday' },
  { value: '0', text: 'Sunday' },
]

export const daysOfWeekShortForm = [
  { value: '1', text: 'Mon' },
  { value: '2', text: 'Tue' },
  { value: '3', text: 'Wed' },
  { value: '4', text: 'Thu' },
  { value: '5', text: 'Fri' },
  { value: '6', text: 'Sat' },
  { value: '0', text: 'Sun' },
]

export const regions = [
  { value: 'ALL_US', text: 'All US' },
  { value: 'NORTHEAST', text: 'Northeast' },
  { value: 'SOUTHEAST', text: 'Southeast' },
  { value: 'MIDWEST', text: 'Midwest' },
  { value: 'SOUTHWEST', text: 'Southwest' },
  { value: 'PACIFIC_NORTHWEST', text: 'Pacific Northwest' },
  { value: 'CALIFORNIA_NEVADA', text: 'California Nevada' },
  { value: 'NORTHERN_US', text: 'Northern US' },
  { value: 'SOUTHERN_US', text: 'Southern US' },
  { value: 'WESTERN_US', text: 'Western US' },
  { value: 'EASTERN_US', text: 'Eastern US' },
  { value: 'NORTHWESTERN_US', text: 'Northwestern US' },
  { value: 'SOUTHERN_CA', text: 'Southern CA' },
  { value: 'NORTHERN_CA', text: 'Northern CA' },
]

const deriveOptionList = (enums, override = {}) => {
  const options = Object.values(enums).map(e => {
    if (override[e]) {
      return {
        value: e,
        text: override[e],
      }
    }
    return {
      value: e,
      text: utils.formatters.formatEnum(e),
    }
  })

  return options
}

export const productTypes = deriveOptionList(graph.enums.ProductType, {
  [graph.enums.ProductType.PrivateSellerInstitutional]:
    'Private Seller - Institutional',
  [graph.enums.ProductType.PrivateSellerIndividual]:
    'Private Seller - Individual',
  [graph.enums.ProductType.Day_1Reo]: 'Day 1 REO',
  [graph.enums.ProductType.FclMarketing]: 'FCL Marketing',
  [graph.enums.ProductType.Reo]: 'REO',
})

export const transactionType = deriveOptionList(graph.enums.EventType, {
  [graph.enums.EventType.ThirdParty]: '3rd Party',
})

export const trusteeSalesChannel = deriveOptionList(graph.enums.LeadAuctionType)

export const assetTypes = deriveOptionList(graph.enums.AssetType)

export const schedulingStatus = deriveOptionList(graph.enums.ScheduleStatus)

export const schedulingFailureReason = deriveOptionList(
  graph.enums.ScheduleFailureReason
)
